import React from 'react';
import FieldProto from "../../../../proto/field-proto";

type Props = {
    className?  : string
    field       : FieldProto
    onClick     : callback      // open dropdown
    children    : any
}

export default function FieldPopover_InlineValueEmpty(props:Props) {

    return (
        <React.Fragment>
            <div className={Classes("ui5-txt-no-accent-default ui5-field-dropdown-inline-editable min-w-125", props.className)} onClick={props.onClick}>
                {_.get(props.field.components, 'ValueIcon', false)}
                {props.field.placeholder}
            </div>
            {props.children}
        </React.Fragment>
    )

}
